// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

import App from './App'
import router from './router'
import i18n from './lang/lang'
// import moment from 'vue-moment'
import VueTruncate from 'vue-truncate-filter'
import FBSignInButton from 'vue-facebook-signin-button' // เอาออกไม่ได้เพราะยังใช้ใน chat2pay อยู่
import VueCarousel from 'vue-carousel'
import VeeValidate from 'vee-validate'
import VueClipboard from 'vue-clipboard2'
import Tooltip from 'vue-directive-tooltip'
// import VueScrollTo from 'vue-scrollto'

import mainMixin from '@/mixins/mainMixin'
import errorMixin from '@/mixins/errorMixin'
import apiMixin from '@/mixins/apiMixin'

import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'
// import 'vue-flash-message/dist/vue-flash-message.min.css'

import './filters'

import FlagIcon from 'vue-flag-icon'
Vue.use(FlagIcon)

import { store } from './store/store'
import PremiumLock from '@/components/elements/PremiumLock'
import PremiumLock2 from '@/components/elements/PremiumLock2'
import PremiumPlanPopup from '@/components/elements/PremiumPlanPopup'
import PremiumPlanPopup2 from '@/components/elements/PremiumPlanPopup2'
import PremiumPlanLayout from '@/components/elements/PremiumPlanLayout'

import VueParticles from 'vue-particles'

import { SimpleSVG } from 'vue-simple-svg'
import MainLayout from '@/components/layouts/Main'
import PartnerLayout from '@/components/layouts/Partner'
import ModalHelp from '@/components/elements/ModalHelp2'
import Vuetify from 'vuetify'
import VueSweetalert2 from 'vue-sweetalert2'

import config from '@/config'

import th from 'vee-validate/dist/locale/th'
// import la from './lang/validate/la'

import 'vuetify/dist/vuetify.min.css'
import { Validator } from 'vee-validate'

import LoadScript from 'vue-plugin-load-script'
import VueCountdown from '@chenfengyuan/vue-countdown'
import VueCookies from 'vue-cookies'
import VueSkeletonLoader from 'skeleton-loader-vue'

Vue.use(VueCookies, { expire: '7d' })
// import VueSanitize from 'vue-sanitize'
// var defaultOptions = {
//   allowedTags: ['a', 'br'],
//   allowedAttributes: {
//     a: ['href']
//   }
// }

// Vue.use(VueSanitize, defaultOptions)
Vue.prototype.$aston = window.aston
Vue.component(VueCountdown.name, VueCountdown)
Vue.use(LoadScript)

import VueGtag from 'vue-gtag'

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-52751393-10' }
  },
  router
)

// import VueAnalytics from 'vue-analytics'
// Vue.use(VueAnalytics, {
//   id: 'UA-52751393-10',
//   router,
//   checkDuplicatedScript: true
// })

const SweetalertoOptions = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, SweetalertoOptions)
Vue.use(Vuetify, {
  theme: {
    primary: config.theme.brand_color
  }
})
Vue.use(VueParticles)

// Vue.use(VueScrollTo)
Vue.use(Tooltip)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Validator.localize({ th: th })
// Validator.localize({ la: la })
Vue.use(VeeValidate, { locale: 'th', events: 'blur' })
Vue.use(VueCarousel)
Vue.use(FBSignInButton)
Vue.use(VueTruncate)
// Vue.use(moment)

Vue.component('vue-skeleton-loader', VueSkeletonLoader)
Vue.component('main-layout', MainLayout)
Vue.component('partner-layout', PartnerLayout)
Vue.component('v-modal-help', ModalHelp)
Vue.component('v-premium-lock', PremiumLock)
Vue.component('v-premium-lock2', PremiumLock2)
Vue.component('v-premium-plan-popup', PremiumPlanPopup)
Vue.component('v-premium-plan-popup2', PremiumPlanPopup2)
Vue.component('v-premium-plan-layout', PremiumPlanLayout)

Vue.component('vue-simple-svg', SimpleSVG)

Vue.config.productionTip = false

// Vue.use(VueScrollTo, {
//   container: 'body',
//   duration: 500,
//   easing: 'ease',
//   offset: 0,
//   force: true,
//   cancelable: true,
//   onStart: false,
//   onDone: false,
//   onCancel: false,
//   x: false,
//   y: true
// })

Validator.extend(
  'isLessThanOrEqual',
  (value, [otherValue]) => {
    return parseFloat(value) <= parseFloat(otherValue)
  },
  {
    hasTarget: true
  }
)

Validator.extend('isUrl', value => {
  var pattern = new RegExp(
    /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  ) // fragment locator
  return pattern.test(value)
})
Validator.extend('excludednew', {
  validate: (value, [...otherValue]) => {
    var obj = value.replace(/,/g, '').replace(/[|]/g, '//#or//')
    return !otherValue.includes(obj)
  }
})
Validator.extend('isPhone', value => {
  var pattern = new RegExp(/^[+]?[0-9]{3,12}$/gim)
  return pattern.test(value)
})
Validator.extend('isHttps', value => {
  var pattern = new RegExp(/^https:\/\//gim)
  return pattern.test(value)
})

Vue.mixin(mainMixin)
Vue.mixin(errorMixin)
Vue.mixin(apiMixin)

Vue.component('v-style', {
  render: function(createElement) {
    return createElement('style', this.$slots.default)
  }
})

import vueLocalStorageWithExpiry from './utils/VueLocalsotrageWithExpiry'
Vue.use(vueLocalStorageWithExpiry)

import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js